export default {
  showChangelog: 'Zobraziť všetky poznámky k vydaniu',
};
